import type { ReactionEmoji } from '@/lib/db/types';

/** Whether we should load reaction breakdown from the API. */
export function shouldLoadReactionBreakdown(postCount: number, localCount: number): boolean {
  return Math.max(postCount, localCount) > 0;
}

export function mergeReactionCounts(
  rows: { emoji: ReactionEmoji }[],
): Partial<Record<ReactionEmoji, number>> {
  const counts: Partial<Record<ReactionEmoji, number>> = {};
  rows.forEach((r) => {
    counts[r.emoji] = (counts[r.emoji] || 0) + 1;
  });
  return counts;
}
